import DeliveryNote from "assets/print-templates/delivery-note.jpg";
import { numberFormatAsString } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { ElementToPrint } from "share-components/templates/print/element";

import { PreviewPrinting } from "share-components/templates/print/print-preview";
import {
  RowElement,
  RowItemElement,
  RowsElementProps,
} from "share-components/templates/print/rows-element";
export const DeliveryNotePrintPreview = observer(() => {
  const {
    deliveryNoteManagement: { openPrintPreview, setProp, deliveryNoteDetail },
  } = useStores();
  const onCloseHandler = useCallback(() => {
    setProp("openPrintPreview", false);
  }, [setProp]);
  const fontSize = "11px";
  const dateElements = useMemo(() => {
    const now = dayjs(deliveryNoteDetail?.date);
    const dateTime: ElementToPrint[] = [
      {
        name: "day",
        left: "13.5cm",
        top: "1.4cm",
        value: now.date().toString(),
        fontSize: fontSize,
      },
      {
        name: "month",
        left: "15.4cm",
        top: "1.4cm",
        value: (now.month() + 1).toString(),
        fontSize: fontSize,
      },
      {
        name: "year",
        left: "17.2cm",
        top: "1.4cm",
        value: now.year().toString(),
        fontSize: fontSize,
      },
    ];
    return dateTime;
  }, [deliveryNoteDetail?.date]);

  const deliveryNoteElements = useMemo(() => {
    const deliveryNoteElms: ElementToPrint[] = [
      {
        name: "numer",
        value: deliveryNoteDetail?.number || "",
        left: "14.4cm",
        top: "2.1cm",
        fontSize: fontSize,
      },
      {
        name: "customerName",
        value: deliveryNoteDetail?.customer?.name || "",
        left: "5cm",
        top: "3cm",
        width: "8cm",
        fontSize: fontSize,
      },
      {
        name: "deliveryAddress",
        value: deliveryNoteDetail?.deliveryAddress?.address || "",
        left: "5cm",
        top: "3.8cm",
        width: "8cm",
        fontSize: fontSize,
      },
      {
        name: "orderNumber",
        value: deliveryNoteDetail?.purchaseOrder?.poNumber || "",
        left: "16.5cm",
        top: "3cm",
        width: "3cm",
        fontSize: fontSize,
      },
      {
        name: "orderDate",
        value: dateTimeDisplay(deliveryNoteDetail?.purchaseOrder?.poDate),
        left: "16.5cm",
        top: "3.8cm",
        width: "3cm",
        fontSize: fontSize,
      },
    ];
    return deliveryNoteElms;
  }, [
    deliveryNoteDetail?.customer?.name,
    deliveryNoteDetail?.deliveryAddress?.address,
    deliveryNoteDetail?.number,
    deliveryNoteDetail?.purchaseOrder?.poDate,
    deliveryNoteDetail?.purchaseOrder?.poNumber,
  ]);

  const deliveryNoteItemElements = useMemo(() => {
    if (!deliveryNoteDetail || !deliveryNoteDetail?.items) {
      return undefined;
    }
    const rowElementProps: RowsElementProps = {
      top: "5.4cm",
      left: "1.4cm",
      rows: [],
      fontSizeDefault: fontSize,
      width: "18cm",
      elementSpacing: "8px",
      lineHeight: "22px",
      height: "3.5cm",
    };

    deliveryNoteDetail.items.forEach((x, idx) => {
      const rowElement: RowElement = {
        elements: [],
      };
      const ordinalNumberElm: RowItemElement = {
        value: (idx + 1).toString(),
        name: "ordinalNumber",
        width: "0.6cm",
      };
      rowElement.elements.push(ordinalNumberElm);
      const productCodeElm: RowItemElement = {
        value: x.product?.code || "",
        name: "productCode",
        width: "2.4cm",
      };
      rowElement.elements.push(productCodeElm);
      const productNameElm: RowItemElement = {
        value: x.product?.name || "",
        name: "productName",
        width: "5.8cm",
      };
      rowElement.elements.push(productNameElm);

      const unitElm: RowItemElement = {
        value: x.product?.unitOfCalculation || "",
        name: "Unit",
        width: "0.9cm",
        textAlign: "flex-end",
      };
      rowElement.elements.push(unitElm);

      const amountElm: RowItemElement = {
        value: numberFormatAsString(x.amount?.toString() || ""),
        name: "unit",
        width: "1.4cm",
        textAlign: "flex-end",
      };
      rowElement.elements.push(amountElm);

      const packageElm: RowItemElement = {
        value: numberFormatAsString(x.package?.toString() || ""),
        name: "package",
        width: "0.8cm",
        textAlign: "flex-end",
      };
      rowElement.elements.push(packageElm);

      const noteElm: RowItemElement = {
        value: x.note || "test",
        name: "note",
        width: "5cm",
        textAlign: "flex-end",
      };
      rowElement.elements.push(noteElm);

      rowElementProps.rows.push(rowElement);
    });

    return rowElementProps;
  }, [deliveryNoteDetail]);

  const elements = useMemo(() => {
    return [...dateElements, ...deliveryNoteElements];
  }, [dateElements, deliveryNoteElements]);
  return (
    <PreviewPrinting
      open={openPrintPreview}
      elements={elements}
      templateImage={DeliveryNote}
      fontSize="13px"
      paperSize={{
        height: "14cm",
        width: "21cm",
      }}
      rowsElement={deliveryNoteItemElements}
      onClose={onCloseHandler}
    />
  );
});
